import { Injectable } from '@angular/core';

import { CreditosConEmpleadosService } from '../../../../modules/finanzas/creditos-con-empleados/creditos-con-empleados.service';
import { CreditosConEmpleadosModel } from '../../../../modules/finanzas/creditos-con-empleados/creditos-con-empleados.model';
import { ensureOk } from '../../entity-form/entity-form.utils';

@Injectable({ providedIn: 'root' })
export class EmployeeCreditEntityService {

  constructor(private creditosConEmpleadosService: CreditosConEmpleadosService) { }

  get(uid: string): Promise<CreditosConEmpleadosModel> {
    return this.creditosConEmpleadosService.get(uid).then(credit => {
      if (!credit) throw new Error();
      return credit;
    });
  }

  create(payload: CreditosConEmpleadosModel): Promise<void> {
    return this.creditosConEmpleadosService.add(payload).then(ensureOk);
  }

  update(uid: string, payload: CreditosConEmpleadosModel): Promise<void> {
    return this.creditosConEmpleadosService.edit({ ...payload, uid }).then(ensureOk);
  }
}
